<template>
  <v-container fluid class="px-16 my-4">
    <FormulaBar msg=""/>
      <v-row style="min-height:60vh;">
        <v-col
          md="6"
          cols="12"
          class="px-0 my-6"
        >
          <FormulaCard />
        </v-col>
        <v-col
          md="6"
          cols="12"
          class="my-auto hidden-sm-and-down"
        >
          <LighteningBoltIndicater />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
// @ is an alias to /src
import FormulaBar from '@/components/Mixer/FormulaBar.vue';
import FormulaCard from '@/components/Mixer/FormulaCard.vue';
import LighteningBoltIndicater from '@/components/Mixer/LighteningBoltIndicater.vue';

export default {
  name: 'Home',
  components: {
    FormulaBar,
    FormulaCard,
    LighteningBoltIndicater
  }
}
</script>

<style scoped>

</style>